import { apiClient } from './apiClient';

export const ticketService = {
  async getTickets(status, search, page = 0, size = 20) {
    const params = new URLSearchParams();
    if (status && status !== 'all') params.append('status', status);
    if (search) params.append('search', search);
    params.append('page', page);
    params.append('size', size);
    return apiClient.get(`/api/support/tickets?${params.toString()}`);
  },

  async getTicketDetail(id) {
    return apiClient.get(`/api/support/tickets/${id}`);
  },

  async createTicket(data) {
    return apiClient.post('/api/support/tickets', data);
  },

  async addReply(ticketId, message) {
    return apiClient.post(`/api/support/tickets/${ticketId}/replies`, { message });
  },

  async getStats() {
    return apiClient.get('/api/support/tickets/stats');
  },
};
